// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2ceIiG6onV8zZ7 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 0 8px;\n  font-size: 12px;\n}\n._2ceIiG6onV8zZ7 .sgUZ-bYymSwvDF {\n  margin-right: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedbackHeaderSection": "_2ceIiG6onV8zZ7",
	"lozenge": "sgUZ-bYymSwvDF"
};
export default ___CSS_LOADER_EXPORT___;
